<template>
  <div class="login-container">
    <h2>正在登录...</h2>
  </div>
</template>

<script>
import axios from 'axios';
import { mlogins,getRouters } from '@/api/index'
import { mapActions } from 'vuex'
export default {
  data() {
    return { code: '' };
  },
  created() {
    const token = localStorage.getItem('userToken')
    
    if (token) {
      this.statusText = '已登录，正在跳转...'
      // 有 token 直接跳首页，守卫会处理路由获取
      this.$router.replace('/')
    } else {
      this.mlogin('ChengHaoNan')
    }
  },
  methods: {
     // 注意：这里请求的是 Nginx 代理后的地址 
     async mlogin(userId) {
      try {
        this.statusText = '正在登录...'
        
        // 登录
        await this.$store.dispatch('user/Login', userId)
        this.statusText = '登录成功！'
        
        // 关键：跳转到 /，让守卫获取路由并跳转到第一个菜单
        this.$router.replace('/')
        
      } catch (error) {
        this.statusText = '登录失败：' + error.message
        //alert('登录失败：' + error.message)
      }
    }
  }
};
</script>